// src/components/Logout.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';

const Logout = () => {
  const navigate = useNavigate();



  useEffect(() => {

    const festival_name = localStorage.getItem('param');

    if (festival_name === "web-series") {
      localStorage.removeItem('token');
      navigate('/web-series');
    } else if (festival_name === "creative-mind-tomorrow") {
      localStorage.removeItem('token');
      navigate('/creative-mind-tomorrow');
    } else if (festival_name === "indian-debut-director") {
      localStorage.removeItem('token');
      navigate('/indian-debut-director');
    }
    else {
      localStorage.removeItem('token');
      navigate('/');
    }


    //navigate('/');


  }, [navigate]);

  return null;
};

export default Logout;
